<template>
    <div class="">

        <input type="hidden" name="stripeToken" :value="nonce">

        <div class="row">
            <div class="col-sm-12">
                <input-wf
                    :label="labelCdc"
                >
                    <template #input="{}">
                        <div class="px-3 py-3">
                            <div id="cardNumber" class="input empty text-gray " ref="card"></div>
                        </div>
                    </template>
                </input-wf>

            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <input-wf
                    :label="labelExpire"
                >
                    <template #input="{}">
                        <div class="px-3 py-3">
                            <div id="cardExpire" class="input empty text-gray " ref="expire"></div>
                        </div>
                    </template>
                </input-wf>
            </div>
            <div class="col-12 col-md-6">
                <input-wf
                        :label="labelCvc"
                >
                    <template #input="{}">
                        <div class="px-3 py-3">
                            <div id="cardCvv" class="input empty text-gray " ref="cvv"></div>
                        </div>
                    </template>
                </input-wf>
            </div>
        </div>

        <template v-if="showButton">
            <div class="row">
                <div class="col"></div>
                <div class="col-lg-4">
                    <button class="btn btn-lg btn-gradient-orange w-100" @click.prevent="() => validateCard( result => {} )">
                        Verify
                    </button>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    export default {
        props: {
            token: {
                type: String,
                default: ''
            },

            labelCdc: {
                type: String,
                default: ''
            },
            labelExpire: {
                type: String,
                default: ''
            },
            labelCvc: {
                type: String,
                default: ''
            },

            showButton: {
                type: [String, Number, Boolean],
                default: false
            },

            defaultShowWidget: {
                type: [String, Number, Boolean],
                default: true
            },

            elementClasses: {
                type: Object,
                default: () => ({
                    focus: 'focused',
                    empty: 'empty',
                    invalid: 'invalid'
                })
            },
            elementStyles: {
                type: Object,
                default: () => ({
                    base: {
                        color: '#32325D',
                        fontWeight: 500,
                        fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',

                        '::placeholder': {
                            color: '#CFD7DF',
                        },
                        ':-webkit-autofill': {
                            color: '#e39f48',
                        },
                    },
                    invalid: {
                        color: '#E25950',

                        '::placeholder': {
                            color: '#FFCCA5',
                        },
                    },
                })
            }
        },
        data() {
            return {
                stripe: null,

                nonce: '',

                elements: null,
                cardNumber: null,
                cardExpiry: null,
                cardCvc: null,

                errorMsg: '',

                disableSubmit: false,
                loading: false
            };
        },
        watch: {
            showWidget( showWidget, oldValue ) {
                if( showWidget === oldValue ) return;

                if( showWidget ) {
                    this.initStripe();
                }
                else {
                    this.destroyStripe();
                }
            }
        },
        mounted() {
            this.initStripe( window.Stripe );
        },
        methods: {
            initStripe( Stripe ) {
                this.disableSubmit = true;
                this.loading = true;

                let stripe = this.stripe = Stripe( this.token );
                let elements = this.elements = stripe.elements({
                    locale: 'auto'
                });

                /*[ this.selectorNumber, this.selectorExpire, this.selectorCvv ]
                    .forEach(( selector ) => {
                        var el = $( selector ).get(0);
                        el.addEventListener('focus', function() {
                            el.classList.add('focused');
                        });
                        el.addEventListener('blur', function() {
                            el.classList.remove('focused');
                        });
                        el.addEventListener('keyup', function() {
                            if (el.value.length === 0) {
                                el.classList.add('empty');
                            } else {
                                el.classList.remove('empty');
                            }
                        });
                    })
                ;*/

                this.cardNumber = elements.create('cardNumber', {
                    style: this.elementStyles,
                    classes: this.elementClasses,
                });
                this.cardNumber.mount( this.$refs.card );

                this.cardExpiry = elements.create('cardExpiry', {
                    style: this.elementStyles,
                    classes: this.elementClasses,
                });
                this.cardExpiry.mount( this.$refs.expire );

                this.cardCvc = elements.create('cardCvc', {
                    style: this.elementStyles,
                    classes: this.elementClasses,
                });
                this.cardCvc.mount( this.$refs.cvv );

                this.cardNumber.addEventListener('change', event => {
                    this.errorMsg = event.error ? event.error.message : '';
                });

                this.disableSubmit = false;
                this.loading = false;
            },

            destroyStripe() {
                this.stripe = null;
                this.elements = null;
                this.widget = null;
            },
            async validateCard( callback = () => {} ) {
                return new Promise(async ( resolve, reject ) => {
                    this.disableSubmit = true;
                    this.loading = true;

                    //let result = await this.stripe.createToken( this.cardNumber );

                    let result = await this.stripe.createPaymentMethod('card', this.cardNumber, {});

                    let { paymentMethod, error } = result;
                    if( error ) {
                        this.errorMsg = result.error.message;

                        setTimeout(() => {
                            this.disableSubmit = false;

                            callback( false, result );

                            resolve( result );
                        }, 1000);
                    }
                    else {
                        this.errorMsg = '';
                        this.nonce = paymentMethod.id;

                        setTimeout(() => {
                            callback( true, result );

                            resolve( result );
                        }, 400);

                    }

                    this.loading = false;

                });
            },

            async handleCardPayment(clientSecret, billingDetails = {}, callback = () => {})
            {
                return new Promise(async ( resolve, reject ) => {
                    let result = await this.stripe.handleCardPayment(
                        clientSecret, this.cardNumber, {
                            payment_method_data: {
                                billing_details: billingDetails
                            }
                        }
                    );

                    callback( result );
                    resolve( result );
                });
            }
        }
    }
</script>
